import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import LinearProgressBar from 'components/LinearProgressBar';
import StockAvatar from 'components/StockAvatar';
import { Star } from 'theme/icon';

function sumPl(items) {
  if (!Array.isArray(items) || items.length === 0) return '0.00';
  const total = items.reduce((sum, item) => sum + (Number(item.pl) || 0), 0);
  return total.toFixed(2);
}

function calcPlPercent(pl, capital) {
  const gain = Number(pl) || 0;
  const cost = Number(capital) || 0;
  if (!cost) return 0;
  return Math.round((gain / cost) * 10000) / 100;
}

function barPercent(list, plPercent) {
  const value = Number(plPercent) || 0;
  const maxAbs = Math.max(...list.map((row) => Math.abs(Number(row.pl_pct) || 0)), 1);
  return (Math.abs(value) / maxAbs) * 100;
}

const stylesLocal = {
  cell: {
    padding: '8px',
  },
};

const StrategySummary = (props) => {
  const list = (props.list || []).map((item) => {
    const pl = Number(item.pl) || 0;
    const capital = Number(item.capital) || Math.abs(Number(item.pl) || 0);
    const pl_pct = item.pl_pct != null
      ? Number(item.pl_pct)
      : (item.roi != null ? Number(item.roi) : calcPlPercent(pl, capital));
    return {
      ...item,
      pl,
      capital: Number(item.capital) || capital,
      pl_pct,
    };
  });

  return (
    <div className="report-panel">
      <div className="report-panel-header">
        <h3 className="report-panel-title">
          {'P/L % · Total P/L = $' + sumPl(list)}
        </h3>
      </div>
      <div className="report-panel-body">
        {props.loading ? (
          <div className="report-loading">
            <Translate value="report_loading" />
          </div>
        ) : (
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Symbol</th>
                <th>Tr#</th>
                <th align="right">P/L</th>
                <th colSpan={2}>P/L %</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item) => (
                <tr key={item.symbol}>
                  <th>
                    <div className="symbol-cell">
                      <StockAvatar item={item} symbol={item.symbol} className="avatar-sm" />
                      <div className="symbol-meta">
                        <RouterLink to={'/stock/' + item.symbol} className="symbol-link">
                          {item.symbol}
                        </RouterLink>
                        {item.dividend === '1' && (
                          <Star className="symbol-star" />
                        )}
                      </div>
                    </div>
                  </th>
                  <th style={stylesLocal.cell}>{item.count}</th>
                  <th align="right" style={stylesLocal.cell}>
                    ${item.pl.toFixed(2)}
                  </th>
                  <th colSpan={2} style={stylesLocal.cell}>
                    <LinearProgressBar
                      percent={barPercent(list, item.pl_pct)}
                      color={item.pl >= 0 ? 'green' : 'red'}
                      value={`${item.pl_pct.toFixed(2)}%`}
                    />
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

StrategySummary.propTypes = {
  list: PropTypes.array,
  loading: PropTypes.bool,
};

function mapStateToProps(reducer) {
  return {
    list: reducer.report.listSymbol,
    loading: reducer.report.loadingSymbol,
  };
}

export default connect(mapStateToProps)(StrategySummary);
